type GetAddressParams = {
  address?: string | null;
  postcode?: string | null;
  place?: string | null;
};

export const getAddress = ({ address, postcode, place }: GetAddressParams): string => {
  const parts = [];

  if (postcode?.trim()) parts.push(postcode.trim());
  if (place?.trim()) parts.push(place.trim());
  if (address?.trim()) parts.push(address.trim());

  if (parts.length === 0) return "";

  if (parts.length === 1) return parts[0];
  if (parts.length === 2) return `${parts[0]} ${parts[1]}`;
  if (parts.length === 3) return `${parts[0]} ${parts[1]}, ${parts[2]}`;

  return parts.join(" ");
};
